import React, { useState } from 'react';
import Button from '../ui/Button';
import Input from '../ui/Input';
import Icon from '../AppIcon';
import authService from '../../utils/authService';

const TOTPVerificationStep = ({ factorId, onSuccess, onBack }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [isVerifying, setIsVerifying] = useState(false);

  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');
    setIsVerifying(true);

    try {
      const result = await authService.challengeAndVerifyTOTP(factorId, code);

      if (!result.success) {
        setError(result.error || 'Invalid code. Please try again.');
        setIsVerifying(false);
        return;
      }

      // Success - the session now has aal2
      onSuccess();
    } catch (err) {
      setError('An unexpected error occurred');
      setIsVerifying(false);
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="text-center">
        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="Shield" size={32} className="text-primary" />
        </div>
        <h2 className="text-2xl font-bold text-foreground mb-2">
          Two-Factor Authentication
        </h2>
        <p className="text-muted-foreground">
          Enter the 6-digit code from your authenticator app
        </p>
      </div>

      {/* Form */}
      <form onSubmit={handleVerify} className="space-y-4">
        <Input
          label="Authentication Code"
          placeholder="000000"
          value={code}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, '').slice(0, 6);
            setCode(value);
            setError('');
          }}
          error={error}
          maxLength={6}
          autoFocus
          className="text-center text-2xl tracking-widest font-mono"
        />

        <Button
          type="submit"
          variant="default"
          size="lg"
          fullWidth
          disabled={code.length !== 6}
          loading={isVerifying}
        >
          Verify & Continue
        </Button>

        {onBack && (
          <Button
            type="button"
            variant="ghost"
            size="sm"
            fullWidth
            onClick={onBack}
            disabled={isVerifying}
            iconName="ArrowLeft"
            iconPosition="left"
          >
            Back to Login
          </Button>
        )}
      </form>

      {/* Help Text */}
      <div className="text-center">
        <p className="text-xs text-muted-foreground">
          Lost access to your authenticator app?{' '}
          <button className="text-primary hover:underline">
            Contact Support
          </button>
        </p>
      </div>
    </div>
  );
};

export default TOTPVerificationStep;
